import React from 'react';
import s from './s.module.less';

const providers = [
    {
        img: 'https://randomuser.me/api/portraits/women/1.jpg',
        content: '“I have enjoyed my relationships with Klarity. As an independent practitioner, I have been provided with the authonomy to apply evidence-based practice without physician oversight when caring for my patients. Klarity has provided a platform for independent business, while still being available for support when needed.”',
        name: 'Margaret Gallagher, PhD,FNP-BC, Board Certified Family Nurse Practitioner',
        date: 'Feb 2024',
    },
    {
        img: 'https://randomuser.me/api/portraits/women/2.jpg',
        content: '“Joining Klarity has been the best decision I have made for my career. I am able to have control over my practice to be able to provide the best care possible. The Klarity platform has provided me with a full schedule of patients and the support team is always ready to help when needed.”',
        name: 'Christine Forge, FNP-C, PMHNP-BC,Family and Psychiatric Mental Health Nurse Practitioner',
        date: 'Aug 2024',
    },
];

export default function WorthProviders() {
    return (
        <div className={s.container}>
            {providers.map((p, i) => (
                <div className={s.card} key={i}>
                    <img className={s.avatar} src={p.img} alt={p.name} />
                    <div className={s.content}>
                        <div className={s.text}>{p.content}</div>
                        <div className={s.name}>{p.name}</div>
                        <div className={s.date}>{p.date}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
